// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3eBds","cell":"ColumnAccessor_cell__2qhRt","firstCellAccent":"ColumnAccessor_firstCellAccent__1ObgM"};